import { Component, OnInit } from '@angular/core';
import { CargaEmpresasService } from '../services/carga-empresas.service';
import { TarjetaEmpresa } from './interface/tarjeta-empresa.interface';
import { firstValueFrom } from 'rxjs';
import { RegistroService } from '../registro.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ComercializadorService } from '../empresa/services/comercializador.service';
@Component({
    selector: 'app-carga-empresas',
    templateUrl: './carga-empresas.component.html',
    styleUrls: ['./carga-empresas.component.css'],
})
export class CargaEmpresasComponent implements OnInit {
    empresas: TarjetaEmpresa[];
    constructor(
        private readonly cargarEmpresasServise: CargaEmpresasService,
        private readonly comercializadorService: ComercializadorService,
        private readonly registroService: RegistroService,
        private readonly router: Router,
        private readonly translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit() {
        this.cargarEmpresas();
        Swal.close();
    }

    async cargarEmpresas() {
        this.empresas = await firstValueFrom(
            this.cargarEmpresasServise.obtenerEmpresas()
        );
    }

    ingresar(idEmpresa: number, nit: string) {
        this.registroService.caracterizacionComercializador = null;
        this.comercializadorService
            .findByAgenteVigiladoId(idEmpresa)
            .subscribe((caracterizacionComercializador) => {
                this.registroService.caracterizacionComercializador =
                    caracterizacionComercializador;
            });
        this.registroService.empresaSelected = idEmpresa.toString();
        this.registroService.nitEmpresaSelected = nit;
        this.registroService.empresasAsociadas = true;
        this.router.navigate(['/inicio'], {
            queryParams: { refresh: Date.now() },
        });
    }
}
